module.exports = __webpack_public_path__ + "static/img/banner-empleo-interior-768x1024.ac9fa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-empleos/banner-empleo-interior-768x1024.jpg
// module id = vwW5
// module chunks = 47